import { render, staticRenderFns } from "./Clasificacion.vue?vue&type=template&id=d5002ac6"
import script from "./Clasificacion.vue?vue&type=script&lang=js"
export * from "./Clasificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports